import script from "./DevicesView.vue?vue&type=script&setup=true&lang=js"
export * from "./DevicesView.vue?vue&type=script&setup=true&lang=js"

import "./DevicesView.vue?vue&type=style&index=0&id=732fbc68&lang=css"

const __exports__ = script;

export default __exports__